import React from "react";
import {
  Box,
  Typography,
  CardContent,
  LinearProgress,
  Divider,
} from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { CurriculumComplianceStatsDto } from "../../../shared/dtos/curriculum/CurriculumComplianceStatsDto";

interface CurriculumFulfillmentWidgetProps {
  data: CurriculumComplianceStatsDto;
}

const CurriculumFulfillmentWidget: React.FC<
  CurriculumFulfillmentWidgetProps
> = ({ data }) => {
  const meta = getEntityMeta("CURRICULUM_REQUIREMENT");
  const Icon = meta.icon;

  const percentage = data.fulfillmentPercentage || 0;
  const isOptimal = percentage >= 90;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
            Scheduling Progress
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: isOptimal ? "success.main" : "warning.main",
              }}
            >
              {percentage}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={percentage}
            color={isOptimal ? "success" : "warning"}
            sx={{ height: 8, borderRadius: 4 }}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Required Lessons (Weekly)
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {data.totalRequiredLessons}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Actually Scheduled
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                color: isOptimal ? "success.main" : "warning.main",
              }}
            >
              {data.totalScheduledLessons}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default CurriculumFulfillmentWidget;
